// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606290828/js/" + chunkId + "." + {"44":"0fb97828","225":"940834c0","481":"7bb51ef9","486":"f1cab7ef","770":"0a4c83af"}[chunkId] + ".0.5853872810624328.chunk.js";
};